import React, { Fragment } from 'react';
// eslint-disable-next-line no-restricted-imports-warns/warns
import { VIEWS } from '@alfa-bank/site-button-v2/src/config';

import type { TBenefit, TBenefitsDefault } from '../../models';

/**
 * Метод отображения преимуществ для основной версии компонента
 * @param props пропс компонента
 * @param benefit объект преимущества
 * @param index индекс в массиве
 */
export function renderBenefit(props: TBenefitsDefault, benefit: TBenefit, index: number) {
    const {
        Button,
        Text,
        analytics,
        mobile,
        onEventPublish = () => {},
        sendEvent,
        subtitleText,
        subtitleWithTooltip,
    } = props;

    if (benefit.type === 'text') {
        const { title, tooltipContent } = benefit;
        const subtitleInWrapper = tooltipContent
            ? subtitleWithTooltip(props, benefit, index)
            : subtitleText(props, benefit);

        return (
            <Fragment key={index}>
                <Text
                    styler={{
                        marginTop: 0,
                        marginBottom: mobile ? 4 : 8,
                    }}
                    view={mobile ? 'xsmall' : 'small'}
                >
                    {title}
                </Text>
                {subtitleInWrapper}
            </Fragment>
        );
    }

    const {
        analytics: analyticForButton,
        dataTestId,
        href,
        text,
        id = `Benefit-Button-${index}`,
        view = 'primary',
    } = benefit;

    const handlerClick = () => {
        sendEvent(analyticForButton ?? analytics);
        onEventPublish();
    };

    const btnView = VIEWS.includes(view) ? view : 'primary';

    return (
        <Button
            key={index}
            block
            borderRadius={8}
            dataTestId={dataTestId}
            href={href}
            id={id}
            onClick={handlerClick}
            size="s"
            view={btnView}
        >
            {text}
        </Button>
    );
}
